(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inay-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inay-offer')) {
  customElements.define('inay-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try {
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.products = this.config.products.filter(p => !p.requires_selling_plan && p.variants.some(v => v.available));
        if (this.config.catalogCount > 250 || !this.products.length) return;
        this.productMap = new Map(this.products.map(p => [String(p.id), p]));
        const current = this.productMap.get(String(this.config.productId));
        if (!current) return;
        this.formatter = new Intl.NumberFormat(this.config.currency === 'EUR' ? 'fr-FR' : (this.config.locale || 'fr'), { style: 'currency', currency: this.config.currency });
        this.minimum = Math.min(...this.products.flatMap(p => p.variants.filter(v => v.available).map(v => v.price)));
        this.count = 2;
        this.filter = 'all';
        this.selections = Array.from({ length: 6 }, () => ({ product: '', variant: '' }));
        const variant = current.variants.find(v => v.id === this.config.variantId && v.available) || current.variants.find(v => v.available);
        this.selections[0] = { product: String(current.id), variant: String(variant.id) };
        this.rows = this.querySelector('[data-rows]');
        this.addButton = this.querySelector('[data-add]');
        this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => {
          if (!input.checked || this.busy) return;
          this.count = Number(input.value);
          this.renderRows();
          this.update();
        }));
        this.querySelector('[data-filter]').addEventListener('change', event => {
          this.filter = event.target.value;
          this.renderRows();
        });
        this.addButton.addEventListener('click', () => this.submit());
        this.renderRows();
        this.update();
        this.querySelector('[data-offer-ui]').hidden = false;
        this.querySelector('[data-fallback]').hidden = true;
      } catch (error) {
        this.querySelector('[data-fallback]').hidden = false;
        this.querySelector('[data-offer-ui]').hidden = true;
      }
    }
    text(key, values = {}) {
      let value = this.config.strings[key] || '';
      for (const [name, replacement] of Object.entries(values)) value = value.replaceAll('__' + name.toUpperCase() + '__', String(replacement));
      return value;
    }
    money(value) { return this.formatter.format(value / 100); }
    selectedVariant(selection) {
      return this.productMap.get(selection.product)?.variants.find(v => String(v.id) === selection.variant && v.available);
    }
    pricing(count = this.count) {
      const variants = this.selections.slice(0, count).map(s => this.selectedVariant(s));
      const prices = variants.map(v => v?.price ?? this.minimum).sort((a, b) => b - a);
      const total = prices.slice(0, count / 2).reduce((a, b) => a + b, 0);
      return { total, saving: prices.reduce((a, b) => a + b, 0) - total, chosen: variants.filter(Boolean).length };
    }
    element(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    }
    option(value, title, disabled = false) {
      const el = this.element('option', '', title);
      el.value = String(value);
      el.disabled = disabled;
      return el;
    }
    renderRows() {
      this.rows.replaceChildren();
      this.selections.slice(0, this.count).forEach((selection, index) => {
        const row = this.element('fieldset', 'inay-offer__row');
        const label = this.text('pair', { count: index + 1 });
        row.append(this.element('legend', '', label));
        const body = this.element('div', 'inay-offer__row-body');
        const img = this.element('img', 'inay-offer__photo');
        img.width = 64; img.height = 64; img.alt = ''; img.loading = 'lazy';
        const choices = this.element('div', 'inay-offer__choices');
        const modelLabel = this.element('label', '', this.text('model'));
        const model = this.element('select');
        model.setAttribute('aria-label', label + ' — ' + this.text('model'));
        model.append(this.option('', this.text('choose')));
        this.products.filter(p => this.filter === 'all' || p.tags.includes(this.filter) || String(p.id) === selection.product).forEach(p => {
          const category = p.tags.includes('Femme') ? this.text('women') : p.tags.includes('Homme') ? this.text('men') : '';
          model.append(this.option(p.id, p.title + (category ? ' · ' + category : '')));
        });
        model.value = selection.product;
        modelLabel.append(model);
        const colorLabel = this.element('label', '', this.text('color'));
        const color = this.element('select');
        color.setAttribute('aria-label', label + ' — ' + this.text('color'));
        colorLabel.append(color);
        const refresh = () => {
          const p = this.productMap.get(selection.product);
          color.replaceChildren();
          if (!p) color.append(this.option('', this.text('choose_color')));
          else p.variants.forEach(v => color.append(this.option(v.id, (v.title === 'Default Title' ? this.text('single') : v.title) + (!v.available ? ' — ' + this.text('unavailable') : ''), !v.available)));
          color.disabled = !p;
          color.value = selection.variant;
          const v = this.selectedVariant(selection);
          const source = v?.featured_image?.src || v?.featured_image?.url || p?.featured_image;
          if (source) { img.src = source; img.style.visibility = 'visible'; img.alt = p.title + ' — ' + (v?.title || ''); }
          else { img.removeAttribute('src'); img.style.visibility = 'hidden'; img.alt = ''; }
        };
        model.addEventListener('change', () => {
          if (this.busy) return;
          selection.product = model.value;
          const p = this.productMap.get(selection.product);
          selection.variant = p ? String(p.variants.find(v => v.available).id) : '';
          refresh(); this.update();
        });
        color.addEventListener('change', () => {
          if (this.busy) return;
          selection.variant = color.value;
          refresh(); this.update();
        });
        refresh();
        choices.append(modelLabel, colorLabel); body.append(img, choices); row.append(body); this.rows.append(row);
      });
    }
    update() {
      const price = this.pricing();
      this.querySelector('[data-progress]').textContent = this.text('progress', { chosen: price.chosen, count: this.count });
      this.querySelector('[data-summary]').hidden = price.chosen !== this.count;
      this.querySelector('[data-total]').textContent = this.money(price.total);
      this.querySelector('[data-saving]').textContent = this.text('saving', { price: this.money(price.saving) });
      this.querySelectorAll('[data-tier-price]').forEach(el => {
        const count = Number(el.dataset.tierPrice), p = this.pricing(count);
        el.textContent = p.chosen === count ? this.money(p.total) : this.text('from', { price: this.money(p.total) });
      });
      this.addButton.disabled = Boolean(this.busy) || price.chosen !== this.count;
      this.addButton.textContent = this.text(price.chosen === this.count ? 'add' : 'incomplete', { count: this.count });
    }
    items() {
      const grouped = new Map();
      this.selections.slice(0, this.count).forEach(selection => {
        const v = this.selectedVariant(selection);
        if (!v) throw new Error('Incomplete selection');
        grouped.set(v.id, (grouped.get(v.id) || 0) + 1);
      });
      return [...grouped].map(([id, quantity]) => ({ id, quantity }));
    }
    async submit() {
      if (this.busy || this.pricing().chosen !== this.count) return;
      this.busy = true;
      this.addButton.disabled = true;
      this.addButton.textContent = this.text('adding');
      this.querySelector('.inay-offer__controls').disabled = true;
      this.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const root = this.config.root.replace(/\/?$/, '/');
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin', signal: controller.signal, body: JSON.stringify({ items: this.items() })
        });
        if (!response.ok) {
          this.failure(response.status === 422 ? 'stock_error' : 'error');
          return;
        }
        window.location.assign(this.config.cartUrl);
      } catch (error) { this.failure('error'); }
      finally { clearTimeout(timer); }
    }
    failure(key) {
      this.removeAttribute('aria-busy');
      this.querySelector('[data-message]').textContent = this.text(key);
      this.querySelector('[data-message]').hidden = false;
      const link = this.querySelector('[data-cart]');
      link.hidden = false;
      this.addButton.textContent = this.text('cart');
      this.addButton.hidden = true;
      link.focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
